import moment from 'moment';
import { requestApi, API_END_POINT } from '../../common/api';
import {
  RESULT_CODE,
  DATE_TIME_FORMAT,
  DISP_COUNT_LIMIT,
  EXTERNALDATA_RESULTPAGING,
  PROCESS_STATUS,
  CREATE_FILE_PROCESS_KBN,
} from '../../common/const';
import { setErrorMessage } from './CommonAction';
import { getMessage } from '../../common/util';
import { ERROR } from '../../common/message';
import config from '../../common/config';

/**
 * state初期化のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_EXTERNAL_DATA_HISTORY_STATE = 'EXTERNALDATA/SET_INIT_EXTERNAL_DATA_HISTORY_STATE';

/**
 * state初期化
 */
export const setInitExternalDataHistoryState = () => ({
  type: SET_INIT_EXTERNAL_DATA_HISTORY_STATE,
});

/**
 * タブtype設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EXTAB = 'EXTERNALDATA/SET_EXTAB';

/**
 * タブtype設定
 * @param   {string}  extab  タブtype
 */
export const setExTab = (extab) => ({ type: SET_EXTAB, extab });

// ----------------------------外部データ取込画面----------------------------

/**
 * 検索条件の処理番号Form設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PROCESS_NO_FROM = 'EXTERNALDATA/SET_PROCESS_NO_FROM';

/**
 * 検索条件の処理番号Form設定
 * @param   {string} processNoFrom 検索条件の処理番号Form
 */
export const setProcessNoFrom = (processNoFrom) => ({
  type: SET_PROCESS_NO_FROM, processNoFrom,
});

/**
 * 検索条件の処理番号To設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PROCESS_NO_TO = 'EXTERNALDATA/SET_PROCESS_NO_TO';

/**
 * 検索条件の処理番号To設定
 * @param   {string}  processNoTo 検索条件の処理番号To
 */
export const setProcessNoTo = (processNoTo) => ({
  type: SET_PROCESS_NO_TO, processNoTo,
});

/**
 * 検索条件の連携日Form設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COOPERATION_DATE_FROM = 'EXTERNALDATA/SET_COOPERATION_DATE_FROM';

/**
 * 検索条件の連携日Form設定
 * @param   {string}  cooperationDateFrom 検索条件の連携日Form
 */
export const setCooperationDateFrom = (cooperationDateFrom) => ({
  type: SET_COOPERATION_DATE_FROM, cooperationDateFrom,
});

/**
 * 検索条件の連携日To設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COOPERATION_DATE_TO = 'EXTERNALDATA/SET_COOPERATION_DATE_TO';

/**
 * 検索条件の連携日To設定
 * @param   {string}  cooperationDateTo 検索条件の連携日To
 */
export const setCooperationDateTo = (cooperationDateTo) => ({
  type: SET_COOPERATION_DATE_TO, cooperationDateTo,
});

/**
 * 検索条件のステータス設定のAction識別文字列
 * @type    {array}  Action識別文字列
 */
export const SET_STATUS = 'EXTERNALDATA/SET_STATUS';

/**
 * 検索条件のステータス設定
 * @param   {object}  status 検索条件のステータス
 */
export const setStatus = (status = []) => ({
  type: SET_STATUS, status,
});

/**
 * 検索条件のTSRコード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TSR_CD = 'EXTERNALDATA/SET_TSR_CD';

/**
 * 検索条件のTSRコード設定
 * @param   {string}  tsrCd 検索条件のTSRコード
 */
export const setTsrCd = (tsrCd) => ({
  type: SET_TSR_CD, tsrCd,
});

/**
 * 検索条件のTSR企業コード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TSR_COMPANY_CD = 'EXTERNALDATA/SET_TSR_COMPANY_CD';

/**
 * 検索条件のTSR企業コード設定
 * @param   {string}  tsrCompanyCd 検索条件のTSR企業コード
 */
export const setTsrCompanyCd = (tsrCompanyCd) => ({
  type: SET_TSR_COMPANY_CD, tsrCompanyCd,
});

/**
 * 検索条件の取引情報キー設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TRADE_KEY = 'EXTERNALDATA/SET_TRADE_KEY';

/**
 * 検索条件の取引情報キー設定
 * @param   {string}  tradeKey 検索条件の取引情報キー
 */
export const setTradeKey = (tradeKey) => ({
  type: SET_TRADE_KEY, tradeKey,
});

/**
 * 現在のページ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_NOW_PAGE = 'EXTERNALDATA/SET_NOW_PAGE';

/**
 * 現在のページ設定
 * @param   {string}  nowPage 現在のページ
 */
export const setNowPage = (nowPage) => ({
  type: SET_NOW_PAGE, nowPage,
});

/**
 * リクエストパラメータ用検索条件設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_CONDITION = 'EXTERNALDATA/SET_SEARCH_CONDITION';

/**
 * リクエストパラメータ用検索条件設定
 * @param   {object}  searchCondition  リクエストパラメータ用検索条件
 */
export const setSearchCondition = (searchCondition) => ({
  type: SET_SEARCH_CONDITION, searchCondition,
});

/**
 * 件数上限メッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_LIMIT_MESSAGE = 'EXTERNALDATA/SET_LIMIT_MESSAGE';

/**
 * 件数上限メッセージ設定
 * @param    {string}  limitMessage 件数上限メッセージ
 */
export const setLimitMessage = (limitMessage) => ({
  type: SET_LIMIT_MESSAGE, limitMessage,
});

/**
 * ダウンロード件数上限ポップアップのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DOWNLOAD_LIMIT_OVER_FLG = 'EXTERNALDATA/SET_DOWNLOAD_LIMIT_OVER_FLG';

/**
 * ダウンロード件数上限ポップアップのフラグ設定設定
 * @param    {string}  limitMessage 件数上限メッセージ
 */
export const setDownloadLimitOverFlg = (downloadLimitOverFlg) => ({
  type: SET_DOWNLOAD_LIMIT_OVER_FLG, downloadLimitOverFlg,
});

/**
 * ポップアップダウンロード件数超過確認メッセージの設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DOWNLOAD_LIMIT_OVER_MSG = 'EXTERNALDATA/SET_DOWNLOAD_LIMIT_OVER_MSG';

/**
 * ポップアップダウンロード件数超過確認メッセージの設定
 * @param    {string}  limitMessage 件数上限メッセージ
 */
export const setDownloadLimitOverMsg = (downloadLimitOverMsg) => ({
  type: SET_DOWNLOAD_LIMIT_OVER_MSG, downloadLimitOverMsg,
});

/**
 * 検索結果設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EXTERNAL_DATA_HISTORY_LIST = 'EXTERNALDATA/SET_EXTERNAL_DATA_HISTORY_LIST';

/**
 * 検索結果設定
 * @param   {object}  userResultList 検索結果
 */
export const setExternalDataHistoryList = (externalDataHistoryList) => ({
  type: SET_EXTERNAL_DATA_HISTORY_LIST, externalDataHistoryList,
});

/**
 * 検索条件初期化
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_SEARCH_CONDITION = 'EXTERNALDATA/SET_INIT_SEARCH_CONDITION';

/**
 * 画面表示検索条件クリア
 */
export const setInitSearchCondition = () => ({
  type: SET_INIT_SEARCH_CONDITION,
});

/**
 * 名刺取込実行ステータスのAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_IMPORT_STATUS = 'TARGET/SET_DOWNLOAD_STATUS';

/**
 * 名刺取込実行ステータス
 * @param   {object}  downloadStatus  名刺取込実行
 */
export const setImportStatus = (importStatus) => ({
  type: SET_IMPORT_STATUS, importStatus,
});

/**
 * ポーリングID設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_POLLING_ID = 'TARGET/SET_POLLING_ID';

/**
 * ポーリングID設定
 * @param   {number} pollingId ポーリングID
 */
export const setPollingId = (pollingId) => (
  { type: SET_POLLING_ID, pollingId }
);

/**
 * 処理番号Formエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_PROCESS_NO_FROM_MSG = 'EXTERNALDATA/SET_ERR_PROCESS_NO_FROM_MSG';

/**
  * 処理番号Formエラーメッセージ設定
  * @param   {string}  errProcessNoFromMsg
  */
export const setErrProcessNoFromMsg = (errProcessNoFromMsg) => ({
  type: SET_ERR_PROCESS_NO_FROM_MSG, errProcessNoFromMsg,
});

/**
 * 処理番号Toエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_PROCESS_NO_TO_MSG = 'EXTERNALDATA/SET_ERR_PROCESS_NO_TO_MSG';

/**
  * 処理番号Toエラーメッセージ設定
  * @param   {string}  errProcessNoToMsg
  */
export const setErrProcessNoToMsg = (errProcessNoToMsg) => ({
  type: SET_ERR_PROCESS_NO_TO_MSG, errProcessNoToMsg,
});

/**
 * 連携日Formエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_COOPERATION_DATE_FROM_MSG = 'EXTERNALDATA/SET_ERR_COOPERATION_DATE_FROM_MSG';

/**
  * 連携日Formエラーメッセージ設定
  * @param   {string}  errCooperationDateFromMsg
  */
export const setErrCooperationDateFromMsg = (errCooperationDateFromMsg) => ({
  type: SET_ERR_COOPERATION_DATE_FROM_MSG, errCooperationDateFromMsg,
});

/**
 * 連携日Toエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_COOPERATION_DATE_TO_MSG = 'EXTERNALDATA/SET_ERR_COOPERATION_DATE_TO_MSG';

/**
  * 連携日Toエラーメッセージ設定
  * @param   {string}  errCooperationDateToMsg
  */
export const setErrCooperationDateToMsg = (errCooperationDateToMsg) => ({
  type: SET_ERR_COOPERATION_DATE_TO_MSG, errCooperationDateToMsg,
});

/**
 * TSRコードエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_TSR_CD_MSG = 'EXTERNALDATA/SET_ERR_TSR_CD_MSG';

/**
  * TSRコードエラーメッセージ設定
  * @param   {string}  errTsrCdMsg
  */
export const setErrTsrCdMsg = (errTsrCdMsg) => ({
  type: SET_ERR_TSR_CD_MSG, errTsrCdMsg,
});

/**
 * TSR企業コードエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_TSR_COMPANY_CD_MSG = 'EXTERNALDATA/SET_ERR_TSR_COMPANY_CD_MSG';

/**
  * TSR企業コードエラーメッセージ設定
  * @param   {string}  errMsgOfficeCount
  */
export const setErrTsrCompanyCdMsg = (errTsrCompanyCdMsg) => ({
  type: SET_ERR_TSR_COMPANY_CD_MSG, errTsrCompanyCdMsg,
});

/**
 * 取引情報キーエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_TRADE_KEY_MSG = 'EXTERNALDATA/SET_ERR_TRADE_KEY_MSG';

/**
  * 取引情報キーエラーメッセージ設定
  * @param   {string}  errMsgOfficeCount
  */
export const setErrTradeKeyMsg = (errTradeKeyMsg) => ({
  type: SET_ERR_TRADE_KEY_MSG, errTradeKeyMsg,
});

/**
 * 処理番号FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_PROCESS_NO_FROM_FLG = 'EXTERNALDATA/SET_ERR_PROCESS_NO_FROM_FLG';

/**
 * 処理番号FROMエラーフラグ設定
 * @param   {boolean}  errProcessNoFromFlg
 */
export const setErrProcessNoFromFlg = (errProcessNoFromFlg) => ({
  type: SET_ERR_PROCESS_NO_FROM_FLG, errProcessNoFromFlg,
});

/**
 * 処理番号TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_PROCESS_NO_TO_FLG = 'EXTERNALDATA/SET_ERR_PROCESS_NO_TO_FLG';

/**
 * 処理番号TOエラーフラグ設定
 * @param   {boolean}  errProcessNoToFlg
 */
export const setErrProcessNoToFlg = (errProcessNoToFlg) => ({
  type: SET_ERR_PROCESS_NO_TO_FLG, errProcessNoToFlg,
});

/**
 * 連携日FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_COOPERATION_DATE_FROM_FLG = 'EXTERNALDATA/SET_ERR_COOPERATION_DATE_FROM_FLG';

/**
 * 連携日FROMエラーフラグ設定
 * @param   {boolean}  errCooperationDateFromFlg
 */
export const setErrCooperationDateFromFlg = (errCooperationDateFromFlg) => ({
  type: SET_ERR_COOPERATION_DATE_FROM_FLG, errCooperationDateFromFlg,
});

/**
 * 連携日TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_COOPERATION_DATE_TO_FLG = 'EXTERNALDATA/SET_ERR_COOPERATION_DATE_TO_FLG';

/**
 * 連携日TOエラーフラグ設定
 * @param   {boolean}  errCooperationDateToFlg
 */
export const setErrCooperationDateToFlg = (errCooperationDateToFlg) => ({
  type: SET_ERR_COOPERATION_DATE_TO_FLG, errCooperationDateToFlg,
});

/**
 * TSRコードエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_TSR_CD_FLG = 'EXTERNALDATA/SET_ERR_TSR_CD_FLG';

/**
 * TSRコードエラーフラグ設定
 * @param   {boolean}  errTsrCdFlg
 */
export const setErrTsrCdFlg = (errTsrCdFlg) => ({
  type: SET_ERR_TSR_CD_FLG, errTsrCdFlg,
});

/**
 * TSR企業コードエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_TSR_COMPANY_CD_FLG = 'EXTERNALDATA/SET_ERR_TSR_COMPANY_CD_FLG';

/**
 * TSR企業コードエラーフラグ設定
 * @param   {boolean}  errTsrCdFlg
 */
export const setErrTsrCompanyCdFlg = (errTsrCompanyCdFlg) => ({
  type: SET_ERR_TSR_COMPANY_CD_FLG, errTsrCompanyCdFlg,
});

/**
 * 取引情報キーエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_TRADE_KEY_FLG = 'EXTERNALDATA/SET_ERR_TRADE_KEY_FLG';

/**
 * 取引情報キーエラーフラグ設定
 * @param   {boolean}  errTsrCdFlg
 */
export const setErrTradeKeyFlg = (errTradeKeyFlg) => ({
  type: SET_ERR_TRADE_KEY_FLG, errTradeKeyFlg,
});

/**
 * 検索条件をもとに名刺連携履歴を取得
 * @param {Dispatch} dispatch             actionを呼ぶための関数
 * @param {string} processNoFrom          処理番号From
 * @param {string} processNoTo            処理番号To
 * @param {string} cooperationDateFrom    連携日From
 * @param {string} cooperationDateTo      連携日To
 * @param {array} status                 ステータス
 * @param {string} tsrCd                  TSRコード
 * @param {string} tsrCompanyCd           TSR企業コード
 * @param {string} tradeKey               取引情報キー
 * @param {*number} pageNumber            ページ番号
 */
export const searchExternalDataHistory = (
  processNoFrom,
  processNoTo,
  cooperationDateFrom,
  cooperationDateTo,
  status,
  tsrCd,
  tsrCompanyCd,
  tradeKey,
  pageNumber,
) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    limit: EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT,
  };
  // 処理番号From
  if (processNoFrom) {
    o.process_no_from = processNoFrom;
  }
  // 処理番号To
  if (processNoTo) {
    o.process_no_to = processNoTo;
  }
  // 連携日From
  if (cooperationDateFrom) {
    o.cooperation_date_from = moment(cooperationDateFrom).format(DATE_TIME_FORMAT.DATE);
  }
  // 連携日To
  if (cooperationDateTo) {
    o.cooperation_date_to = moment(cooperationDateTo).format(DATE_TIME_FORMAT.DATE);
  }
  // ステータス
  if (status && status.length > 0) {
    o.status_list = status;
  }
  // TSRコード
  if (tsrCd && tsrCd.length > 0) {
    o.tsr_cd = tsrCd;
  }
  // TSR企業コード
  if (tsrCompanyCd && tsrCompanyCd.length > 0) {
    o.tsr_company_cd = tsrCompanyCd;
  }
  // 取引情報キー
  if (tradeKey && tradeKey.length > 0) {
    o.torihiki_info_key = tradeKey;
  }

  const param = { ...o };

  o.page_no = pageNumber;

  dispatch(setSearchCondition(param));
  dispatch(setLimitMessage(''));

  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_EXTERNALDATA_HISTORY, o);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return null;
  }

  const searchCount = ret.response.all_count;
  if (searchCount > DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY) {
    dispatch(setLimitMessage('※最大10,000件までの表示となります。'));
  } else {
    dispatch(setLimitMessage(''));
  }

  // 検索結果のセット
  return ret.response;
};

export const searchPaging = (page) => async (dispatch, getState) => {
  const { searchCondition } = getState().externaldata;

  // 検索条件
  const o = { ...searchCondition };

  // ページ番号
  o.page_no = page;

  o.limit = EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT;

  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_EXTERNALDATA_HISTORY, o);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return null;
  }

  const searchCount = ret.response.all_count;
  if (searchCount > DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY) {
    dispatch(setLimitMessage('※最大10,000件までの表示となります。'));
  } else {
    dispatch(setLimitMessage(''));
  }

  // 検索結果のセット
  return ret.response;
};

/**
 * CSVファイル_対象件数取得
 */
export const createDownloadFile = () => async (dispatch, getState) => {
  const {
    searchCondition,
  } = getState().externaldata;

  // 検索条件
  const o = { ...searchCondition };
  o.limit = 1;

  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_EXTERNALDATA_HISTORY, o);

  // エラーが発生した場合
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return 0;
  }

  const searchCount = ret.response.all_count;
  if (searchCount > DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY) {
    dispatch(setDownloadLimitOverMsg(getMessage('検索結果{0}件のうち、10,000件が出力対象となります。ダウンロードしますか？', Number(searchCount).toLocaleString())));
    dispatch(setDownloadLimitOverFlg(true));
  }

  return ret.response.all_count;
};

/**
 * CSVファイルダウンロード
 * @param   {Dispatch} dispatch   actionを呼ぶための関数
 */
export const executeFileDownload = () => async (dispatch, getState) => {
  const {
    searchCondition,
  } = getState().externaldata;

  // 検索条件
  const o = { ...searchCondition };
  o.limit = DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY;

  // API実行
  const ret = await requestApi(
    dispatch,
    API_END_POINT.DOWNLOAD_EXTERNALDATA_HISTORY,
    o,
    false,
    true,
  );
  // エラーが発生した場合
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return false;
  }

  const array = [
    'commonHistory_',
    moment().format(DATE_TIME_FORMAT.DATE_TIME_FULL_FILE),
    '.csv',
  ];
  // ダウンロード処理
  const downLoadLink = document.createElement('a');
  document.body.appendChild(downLoadLink);
  downLoadLink.download = (array.join(''));
  downLoadLink.href = window.URL.createObjectURL(ret.response);
  downLoadLink.click();
  return true;
};

/**
 * 名刺取込ステータス取得
 * ・取得したステータスが処理中の場合、TRUEを返却
 */
export const getImportStatus = () => async (dispatch) => {
  // 処理区分:ステータス確認
  const o = {
    process_type: CREATE_FILE_PROCESS_KBN.DOWNLOAD_POSSIBLE,
  };
  // 名刺取込実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_IMPORT_BUSINESSCARD_STATUS, o);

  // 認証エラーの場合は何も設定しない
  if (ret.result === RESULT_CODE.ERROR && ret.response === null) {
    return false;
  }

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーの場合、名刺取込ステータスを初期化
    dispatch(setImportStatus());
    dispatch(setErrorMessage(ERROR.E09010));
    return false;
  }
  // 正常終了の場合、名刺取込ステータス情報を更新
  dispatch(setImportStatus(ret.response));
  // ステータスが処理中かどうかを返却
  return ret.response.status === PROCESS_STATUS.PROCESSING;
};

/**
  * ポーリング処理停止
  */
export const stopImportPolling = () => (dispatch, getState) => {
  const { pollingId } = getState().externaldata;
  // ポーリングIDが設定されている場合、ポーリング処理停止
  if (pollingId) {
    clearInterval(pollingId);
    dispatch(setPollingId());
  }
};

/**
  * ポーリング処理開始
 */
export const startImportPolling = () => (dispatch) => {
  const pollingId = setInterval(async () => {
    const res = await dispatch(getImportStatus());
    if (!res) {
      // ダウンロードステータスが処理中以外の場合、ポーリング処理を停止
      dispatch(stopImportPolling());
    }
  }, config.IMPORT_POLLING.BUSINESSCARD);
  dispatch(setPollingId(pollingId));
};

/**
 * 名刺取込実行
 */
export const importBusinesscard = () => async (dispatch) => {
  // 処理区分:名刺情報取込
  const o = {
    process_type: CREATE_FILE_PROCESS_KBN.CREATE_FILE,
  };

  // 名刺情報取込実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_IMPORT_BUSINESSCARD_STATUS, o);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーの場合、名刺取込ステータスを初期化
    dispatch(setImportStatus());
    dispatch(setErrorMessage(ERROR.E09010));
  } else {
    // 正常終了の場合、名刺取込ステータス情報を更新、ポーリング処理開始
    dispatch(setImportStatus(ret.response));
    // ポージング処理開始
    await dispatch(startImportPolling());
  }
};

// ----------------------------外部送信画面----------------------------

/**
 * state初期化のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_EXTERNAL_DATA_SEND_HISTORY_STATE = 'EXTERNALDATA/SET_INIT_EXTERNAL_DATA_SEND_HISTORY_STATE';

/**
 * state初期化
 */
export const setInitExternalDataSendHistoryState = () => ({
  type: SET_INIT_EXTERNAL_DATA_SEND_HISTORY_STATE,
});

/**
 * 検索条件の処理番号Form設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EX_PROCESS_NO_FROM = 'EXTERNALDATA/SET_EX_PROCESS_NO_FROM';

/**
 * 検索条件の処理番号Form設定
 * @param   {string} exProcessNoFrom 検索条件の処理番号Form
 */
export const setExProcessNoFrom = (exProcessNoFrom) => ({
  type: SET_EX_PROCESS_NO_FROM, exProcessNoFrom,
});

/**
 * 検索条件の処理番号To設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EX_PROCESS_NO_TO = 'EXTERNALDATA/SET_EX_PROCESS_NO_TO';

/**
 * 検索条件の処理番号To設定
 * @param   {string}  exProcessNoTo 検索条件の処理番号To
 */
export const setExProcessNoTo = (exProcessNoTo) => ({
  type: SET_EX_PROCESS_NO_TO, exProcessNoTo,
});

/**
 * 検索条件の作成日Form設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CREATE_DATE_FROM = 'EXTERNALDATA/SET_CREATE_DATE_FROM';

/**
 * 検索条件の作成日Form設定
 * @param   {string}  createDateFrom 検索条件の作成日Form
 */
export const setCreateDateFrom = (createDateFrom) => ({
  type: SET_CREATE_DATE_FROM, createDateFrom,
});

/**
 * 検索条件の作成日To設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CREATE_DATE_TO = 'EXTERNALDATA/SET_CREATE_DATE_TO';

/**
 * 検索条件の作成日To設定
 * @param   {string}  createDateTo 検索条件の作成日To
 */
export const setCreateDateTo = (createDateTo) => ({
  type: SET_CREATE_DATE_TO, createDateTo,
});

/**
 * 検索条件の連絡先：処理番号設定のAction識別文字列
 * @type    {array}  Action識別文字列
 */
export const SET_LINKAGE_PROCESS_NO = 'EXTERNALDATA/SET_CONTACT_PROCESS_NO';

/**
 * 検索条件の連絡先：処理番号設定
 * @param   {object}  linkageProcessNo 検索条件の連絡先：処理番号
 */
export const setLinkageProcessNo = (linkageProcessNo = []) => ({
  type: SET_LINKAGE_PROCESS_NO, linkageProcessNo,
});

/**
 * 現在のページ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EX_NOW_PAGE = 'EXTERNALDATA/SET_EX_NOW_PAGE';

/**
 * 現在のページ設定
 * @param   {string}  exNowPage 現在のページ
 */
export const setExNowPage = (exNowPage) => ({
  type: SET_EX_NOW_PAGE, exNowPage,
});

/**
 * リクエストパラメータ用検索条件設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EX_SEARCH_CONDITION = 'EXTERNALDATA/SET_EX_SEARCH_CONDITION';

/**
 * リクエストパラメータ用検索条件設定
 * @param   {object}  exSearchCondition  リクエストパラメータ用検索条件
 */
export const setExSearchCondition = (exSearchCondition) => ({
  type: SET_EX_SEARCH_CONDITION, exSearchCondition,
});

/**
 * 検索結果設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EXTERNAL_DATA_SEND_HISTORY_LIST = 'EXTERNALDATA/SET_EXTERNAL_DATA_SEND_HISTORY_LIST';

/**
 * 件数上限メッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EX_LIMIT_MESSAGE = 'EXTERNALDATA/SET_EX_LIMIT_MESSAGE';

/**
 * 件数上限メッセージ設定
 * @param    {string}  exLimitMessage 件数上限メッセージ
 */
export const setExLimitMessage = (exLimitMessage) => ({
  type: SET_EX_LIMIT_MESSAGE, exLimitMessage,
});

/**
 * 検索結果設定
 * @param   {object}  userResultList 検索結果
 */
export const setExternalDataSendHistoryList = (externalDataSendHistoryList) => ({
  type: SET_EXTERNAL_DATA_SEND_HISTORY_LIST, externalDataSendHistoryList,
});

/**
 * 検索条件初期化
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_EX_SEARCH_CONDITION = 'EXTERNALDATA/SET_INIT_EX_SEARCH_CONDITION';

/**
 * 画面表示検索条件クリア
 */
export const setInitExSearchCondition = () => ({
  type: SET_INIT_EX_SEARCH_CONDITION,
});

/**
 * 処理番号Formエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_EX_PROCESS_NO_FROM_MSG = 'EXTERNALDATA/SET_ERR_EX_PROCESS_NO_FROM_MSG';

/**
  * 処理番号Formエラーメッセージ設定
  * @param   {string}  errExProcessNoFromMsg
  */
export const setErrExProcessNoFromMsg = (errExProcessNoFromMsg) => ({
  type: SET_ERR_EX_PROCESS_NO_FROM_MSG, errExProcessNoFromMsg,
});

/**
 * 処理番号Toエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_EX_PROCESS_NO_TO_MSG = 'EXTERNALDATA/SET_ERR_EX_PROCESS_NO_TO_MSG';

/**
  * 処理番号Toエラーメッセージ設定
  * @param   {string}  errExProcessNoToMsg
  */
export const setErrExProcessNoToMsg = (errExProcessNoToMsg) => ({
  type: SET_ERR_EX_PROCESS_NO_TO_MSG, errExProcessNoToMsg,
});

/**
 * 作成日Formエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_CREATE_DATE_FROM_MSG = 'EXTERNALDATA/SET_ERR_CREATE_DATE_FROM_MSG';

/**
  * 作成日Formエラーメッセージ設定
  * @param   {string}  errCreateDateFromMsg
  */
export const setErrCreateDateFromMsg = (errCreateDateFromMsg) => ({
  type: SET_ERR_CREATE_DATE_FROM_MSG, errCreateDateFromMsg,
});

/**
 * 作成日Toエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_CREATE_DATE_TO_MSG = 'EXTERNALDATA/SET_ERR_CREATE_DATE_TO_MSG';

/**
  * 作成日Toエラーメッセージ設定
  * @param   {string}  errCreateDateToMsg
  */
export const setErrCreateDateToMsg = (errCreateDateToMsg) => ({
  type: SET_ERR_CREATE_DATE_TO_MSG, errCreateDateToMsg,
});

/**
 * 取引情報キーエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_LINKAGE_PROCESS_NO_MSG = 'EXTERNALDATA/SET_ERR_LINKAGE_PROCESS_NO_MSG';

/**
  * 取引情報キーエラーメッセージ設定
  * @param   {string}  errMsgOfficeCount
  */
export const setErrLinkageProcessNoMsg = (errLinkageProcessNoMsg) => ({
  type: SET_ERR_LINKAGE_PROCESS_NO_MSG, errLinkageProcessNoMsg,
});

/**
 * 処理番号FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_EX_PROCESS_NO_FROM_FLG = 'EXTERNALDATA/SET_ERR_EX_PROCESS_NO_FROM_FLG';

/**
 * 処理番号FROMエラーフラグ設定
 * @param   {boolean}  errExProcessNoFromFlg
 */
export const setErrExProcessNoFromFlg = (errExProcessNoFromFlg) => ({
  type: SET_ERR_EX_PROCESS_NO_FROM_FLG, errExProcessNoFromFlg,
});

/**
 * 処理番号TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_EX_PROCESS_NO_TO_FLG = 'EXTERNALDATA/SET_ERR_EX_PROCESS_NO_TO_FLG';

/**
 * 処理番号TOエラーフラグ設定
 * @param   {boolean}  errExProcessNoToFlg
 */
export const setErrExProcessNoToFlg = (errExProcessNoToFlg) => ({
  type: SET_ERR_EX_PROCESS_NO_TO_FLG, errExProcessNoToFlg,
});

/**
 * 連携日FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_CREATE_DATE_FROM_FLG = 'EXTERNALDATA/SET_ERR_CREATE_DATE_FROM_FLG';

/**
 * 連携日FROMエラーフラグ設定
 * @param   {boolean}  errCreateDateFromFlg
 */
export const setErrCreateDateFromFlg = (errCreateDateFromFlg) => ({
  type: SET_ERR_CREATE_DATE_FROM_FLG, errCreateDateFromFlg,
});

/**
 * 連携日TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_CREATE_DATE_TO_FLG = 'EXTERNALDATA/SET_ERR_CREATE_DATE_TO_FLG';

/**
 * 連携日TOエラーフラグ設定
 * @param   {boolean}  errCreateDateToFlg
 */
export const setErrCreateDateToFlg = (errCreateDateToFlg) => ({
  type: SET_ERR_CREATE_DATE_TO_FLG, errCreateDateToFlg,
});

/**
 * 取引情報キーエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_LINKAGE_PROCESS_NO_FLG = 'EXTERNALDATA/SET_ERR_LINKAGE_PROCESS_NO_FLG';

/**
 * 取引情報キーエラーフラグ設定
 * @param   {boolean}  errTsrCdFlg
 */
export const setErrLinkageProcessNoFlg = (errLinkageProcessNoFlg) => ({
  type: SET_ERR_LINKAGE_PROCESS_NO_FLG, errLinkageProcessNoFlg,
});

/**
 * 検索条件をもとに外部送信履歴を取得
 * @param {Dispatch} dispatch             actionを呼ぶための関数
 * @param {string} exProcessNoFrom        処理番号From
 * @param {string} exProcessNoTo          処理番号To
 * @param {string} createDateFrom         作成日From
 * @param {string} createDateTo           作成日To
 * @param {string} linkageProcessNo       連絡先：処理番号
 * @param {*number} exPageNumber            ページ番号
 */
export const searchExternalDataSendHistory = (
  exProcessNoFrom,
  exProcessNoTo,
  createDateFrom,
  createDateTo,
  linkageProcessNo,
  exPageNumber,
) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    limit: EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT,
  };
  // 処理番号From
  if (exProcessNoFrom) {
    o.process_no_from = exProcessNoFrom;
  }
  // 処理番号To
  if (exProcessNoTo) {
    o.process_no_to = exProcessNoTo;
  }
  // 作成日From
  if (createDateFrom) {
    o.create_date_from = moment(createDateFrom).format(DATE_TIME_FORMAT.DATE);
  }
  // 作成日To
  if (createDateTo) {
    o.create_date_to = moment(createDateTo).format(DATE_TIME_FORMAT.DATE);
  }
  // 連携先：処理番号
  if (linkageProcessNo && linkageProcessNo.length > 0) {
    o.linkage_process_no = linkageProcessNo;
  }

  const param = { ...o };

  o.page_no = exPageNumber;

  dispatch(setExSearchCondition(param));
  dispatch(setExLimitMessage(''));

  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_EXTERNALDATA_SEND_HISTORY, o);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return null;
  }

  const searchCount = ret.response.all_count;
  if (searchCount > DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY) {
    dispatch(setExLimitMessage('※最大10,000件までの表示となります。'));
  } else {
    dispatch(setExLimitMessage(''));
  }

  // 検索結果のセット
  return ret.response;
};

export const searchExPaging = (page) => async (dispatch, getState) => {
  const { exSearchCondition } = getState().externaldata;

  // 検索条件
  const o = { ...exSearchCondition };

  // ページ番号
  o.page_no = page;

  o.limit = EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT;

  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_EXTERNALDATA_SEND_HISTORY, o);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return null;
  }

  const searchCount = ret.response.all_count;
  if (searchCount > DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY) {
    dispatch(setExLimitMessage('※最大10,000件までの表示となります。'));
  } else {
    dispatch(setExLimitMessage(''));
  }

  // 検索結果のセット
  return ret.response;
};

/**
 * CSVファイルダウンロード
 * @param   {Dispatch} dispatch   actionを呼ぶための関数
 */
export const executeExFileDownload = () => async (dispatch, getState) => {
  const {
    exSearchCondition,
  } = getState().externaldata;

  // 検索条件
  const o = { ...exSearchCondition };
  delete o.limit;

  // API実行
  const ret = await requestApi(
    dispatch,
    API_END_POINT.DOWNLOAD_EXTERNALDATA_SEND_HISTORY,
    o,
    false,
    true,
  );
  // エラーが発生した場合
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return false;
  }

  const array = [
    'externalHistory_',
    moment().format(DATE_TIME_FORMAT.DATE_TIME_FULL_FILE),
    '.csv',
  ];
  // ダウンロード処理
  const downLoadLink = document.createElement('a');
  document.body.appendChild(downLoadLink);
  downLoadLink.download = (array.join(''));
  downLoadLink.href = window.URL.createObjectURL(ret.response);
  downLoadLink.click();
  return true;
};
